import { Component, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { IconComponent } from "../../helper/icon/icon.component";
import { ApiService } from '../../service/api.service';
import { AccountService } from '../../service/account.service';

interface TroubleshootStep {
  failure: boolean;
  title: string;
  error: string|null;
  correct: boolean;
}

@Component({
  selector: 'app-troubleshoot-perks',
  imports: [MatDialogModule, MatProgressBarModule, MatListModule, IconComponent],
  templateUrl: './troubleshoot-perks.component.html',
  styleUrl: './troubleshoot-perks.component.less'
})
export class TroubleshootPerksComponent {

  pending: boolean = true;

  steps: TroubleshootStep[] = [
    {
      title: "Patreon connection",
      error: null,
      failure: false,
      correct: false,
    },
    {
      title: "VRChat connection",
      error: "You have recently updated your VRChat username, but have not updated your connection here. This has been fixed automatically.",
      failure: true,
      correct: true,
    },
    {
      title: "In-Game files",
      error: "Your username has not yet been syncronised with the in-game files. This process should not take longer than 15 minutes after connecting your accounts. If this issue persists, please contact us via Discord.",
      failure: true,
      correct: false,
    }
  ]

  api = inject(ApiService);
  accountService = inject(AccountService);

  constructor() {
    this.api.get("account/troubleshoot_perks.php").subscribe((data: any) => {
      this.pending = false;
      this.steps = data.steps;
      if (this.steps.filter(step => step.failure).length > 0) {
        // reload the account
        this.accountService.loadAccount();
      }
    });
  }

  get failedSteps(): TroubleshootStep[] {
    return this.steps.filter(step => step.failure);
  }
  
  isSuccess(): boolean {
    return this.steps.every(step => !step.failure);
  }

}
